/* eslint-disable */
import { Category, ProductColorItem } from "../common/common";

export const protobufPackage = "store.api.store";

export interface ListSearchKeywordsResponse {
  /** 搜索欄 placeholder */
  placeholder: string;
  /** 建議的搜索關鍵字 */
  keywords: string[];
  /** 熱門搜索 */
  hotKeywords: ListSearchKeywordsResponse_HotKeyword[];
}

export interface ListSearchKeywordsResponse_HotKeyword {
  /** 編號 */
  id: string;
  /** 關鍵字 */
  keyword: string;
}

export interface SearchProductsRequest {
  /** 搜索關鍵字, use for search keyword */
  keyword?:
    | string
    | undefined;
  /** 熱門關鍵字編號, use for search hot keyword */
  hotId?:
    | string
    | undefined;
  /** 動態商品館編號, use for redirect link */
  shopWindowId?:
    | string
    | undefined;
  /** 動態商品館編號-預覽, use for redirect link */
  previewShopWindowId?:
    | string
    | undefined;
  /** Required. 是否算點擊次數 */
  recordHit: boolean;
  /** Optional. 廣告參數 */
  adId: string;
  /** Optional. 廣告參數設定流水號 */
  adSeq: number;
}

export interface SearchProductsResponse {
  /** dynamic page title or search keyword */
  title: string;
  results: SearchProductsResponse_SearchContent[];
}

/** SearchContent defines the content for searched products. */
export interface SearchProductsResponse_SearchContent {
  big: Category | undefined;
  content: ProductColorItem | undefined;
}

function createBaseListSearchKeywordsResponse(): ListSearchKeywordsResponse {
  return { placeholder: "", keywords: [], hotKeywords: [] };
}

export const ListSearchKeywordsResponse = {
  fromJSON(object: any): ListSearchKeywordsResponse {
    return {
      placeholder: isSet(object.placeholder) ? String(object.placeholder) : "",
      keywords: Array.isArray(object?.keywords) ? object.keywords.map((e: any) => String(e)) : [],
      hotKeywords: Array.isArray(object?.hotKeywords)
        ? object.hotKeywords.map((e: any) => ListSearchKeywordsResponse_HotKeyword.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListSearchKeywordsResponse): unknown {
    const obj: any = {};
    message.placeholder !== undefined && (obj.placeholder = message.placeholder);
    if (message.keywords) {
      obj.keywords = message.keywords.map((e) => e);
    } else {
      obj.keywords = [];
    }
    if (message.hotKeywords) {
      obj.hotKeywords = message.hotKeywords.map((e) => e ? ListSearchKeywordsResponse_HotKeyword.toJSON(e) : undefined);
    } else {
      obj.hotKeywords = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListSearchKeywordsResponse>, I>>(base?: I): ListSearchKeywordsResponse {
    return ListSearchKeywordsResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListSearchKeywordsResponse>, I>>(object: I): ListSearchKeywordsResponse {
    const message = createBaseListSearchKeywordsResponse();
    message.placeholder = object.placeholder ?? "";
    message.keywords = object.keywords?.map((e) => e) || [];
    message.hotKeywords = object.hotKeywords?.map((e) => ListSearchKeywordsResponse_HotKeyword.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListSearchKeywordsResponse_HotKeyword(): ListSearchKeywordsResponse_HotKeyword {
  return { id: "", keyword: "" };
}

export const ListSearchKeywordsResponse_HotKeyword = {
  fromJSON(object: any): ListSearchKeywordsResponse_HotKeyword {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      keyword: isSet(object.keyword) ? String(object.keyword) : "",
    };
  },

  toJSON(message: ListSearchKeywordsResponse_HotKeyword): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.keyword !== undefined && (obj.keyword = message.keyword);
    return obj;
  },

  create<I extends Exact<DeepPartial<ListSearchKeywordsResponse_HotKeyword>, I>>(
    base?: I,
  ): ListSearchKeywordsResponse_HotKeyword {
    return ListSearchKeywordsResponse_HotKeyword.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListSearchKeywordsResponse_HotKeyword>, I>>(
    object: I,
  ): ListSearchKeywordsResponse_HotKeyword {
    const message = createBaseListSearchKeywordsResponse_HotKeyword();
    message.id = object.id ?? "";
    message.keyword = object.keyword ?? "";
    return message;
  },
};

function createBaseSearchProductsRequest(): SearchProductsRequest {
  return {
    keyword: undefined,
    hotId: undefined,
    shopWindowId: undefined,
    previewShopWindowId: undefined,
    recordHit: false,
    adId: "",
    adSeq: 0,
  };
}

export const SearchProductsRequest = {
  fromJSON(object: any): SearchProductsRequest {
    return {
      keyword: isSet(object.keyword) ? String(object.keyword) : undefined,
      hotId: isSet(object.hotId) ? String(object.hotId) : undefined,
      shopWindowId: isSet(object.shopWindowId) ? String(object.shopWindowId) : undefined,
      previewShopWindowId: isSet(object.previewShopWindowId) ? String(object.previewShopWindowId) : undefined,
      recordHit: isSet(object.recordHit) ? Boolean(object.recordHit) : false,
      adId: isSet(object.adId) ? String(object.adId) : "",
      adSeq: isSet(object.adSeq) ? Number(object.adSeq) : 0,
    };
  },

  toJSON(message: SearchProductsRequest): unknown {
    const obj: any = {};
    message.keyword !== undefined && (obj.keyword = message.keyword);
    message.hotId !== undefined && (obj.hotId = message.hotId);
    message.shopWindowId !== undefined && (obj.shopWindowId = message.shopWindowId);
    message.previewShopWindowId !== undefined && (obj.previewShopWindowId = message.previewShopWindowId);
    message.recordHit !== undefined && (obj.recordHit = message.recordHit);
    message.adId !== undefined && (obj.adId = message.adId);
    message.adSeq !== undefined && (obj.adSeq = Math.round(message.adSeq));
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchProductsRequest>, I>>(base?: I): SearchProductsRequest {
    return SearchProductsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SearchProductsRequest>, I>>(object: I): SearchProductsRequest {
    const message = createBaseSearchProductsRequest();
    message.keyword = object.keyword ?? undefined;
    message.hotId = object.hotId ?? undefined;
    message.shopWindowId = object.shopWindowId ?? undefined;
    message.previewShopWindowId = object.previewShopWindowId ?? undefined;
    message.recordHit = object.recordHit ?? false;
    message.adId = object.adId ?? "";
    message.adSeq = object.adSeq ?? 0;
    return message;
  },
};

function createBaseSearchProductsResponse(): SearchProductsResponse {
  return { title: "", results: [] };
}

export const SearchProductsResponse = {
  fromJSON(object: any): SearchProductsResponse {
    return {
      title: isSet(object.title) ? String(object.title) : "",
      results: Array.isArray(object?.results)
        ? object.results.map((e: any) => SearchProductsResponse_SearchContent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SearchProductsResponse): unknown {
    const obj: any = {};
    message.title !== undefined && (obj.title = message.title);
    if (message.results) {
      obj.results = message.results.map((e) => e ? SearchProductsResponse_SearchContent.toJSON(e) : undefined);
    } else {
      obj.results = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchProductsResponse>, I>>(base?: I): SearchProductsResponse {
    return SearchProductsResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SearchProductsResponse>, I>>(object: I): SearchProductsResponse {
    const message = createBaseSearchProductsResponse();
    message.title = object.title ?? "";
    message.results = object.results?.map((e) => SearchProductsResponse_SearchContent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSearchProductsResponse_SearchContent(): SearchProductsResponse_SearchContent {
  return { big: undefined, content: undefined };
}

export const SearchProductsResponse_SearchContent = {
  fromJSON(object: any): SearchProductsResponse_SearchContent {
    return {
      big: isSet(object.big) ? Category.fromJSON(object.big) : undefined,
      content: isSet(object.content) ? ProductColorItem.fromJSON(object.content) : undefined,
    };
  },

  toJSON(message: SearchProductsResponse_SearchContent): unknown {
    const obj: any = {};
    message.big !== undefined && (obj.big = message.big ? Category.toJSON(message.big) : undefined);
    message.content !== undefined &&
      (obj.content = message.content ? ProductColorItem.toJSON(message.content) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchProductsResponse_SearchContent>, I>>(
    base?: I,
  ): SearchProductsResponse_SearchContent {
    return SearchProductsResponse_SearchContent.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SearchProductsResponse_SearchContent>, I>>(
    object: I,
  ): SearchProductsResponse_SearchContent {
    const message = createBaseSearchProductsResponse_SearchContent();
    message.big = (object.big !== undefined && object.big !== null) ? Category.fromPartial(object.big) : undefined;
    message.content = (object.content !== undefined && object.content !== null)
      ? ProductColorItem.fromPartial(object.content)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
